import React from 'react'

import { createSvgIcon } from './utils/create-svg-icon'

export const CheckIcon = createSvgIcon(
  <>
    <title>check</title>
    <g
      className="nc-icon-wrapper"
      fill="#222222"
      stroke="#222222"
      strokeLinecap="square"
      strokeLinejoin="miter"
      strokeWidth="1"
      transform="translate(0.5 0.5)"
    >
      <polyline
        fill="none"
        points="2 16 11 25 30 6"
        stroke="#222222"
        strokeMiterlimit="10"
      />
    </g>
  </>
)
